import { apiClient } from '@/lib/apiClient';
import type { ApiSuccess, PaginationMeta } from '@/types/api';
import type { SchoolDailyReportDay } from '@/types/dailyReport';

export interface SchoolDailyReportParams {
  /** Omitted means today, decided in IST by the server. */
  onDate?: string;
  teacherUuid?: string;
  classSectionUuid?: string;
  page: number;
  limit: number;
}

/**
 * The office's read of every teacher's daily reports.
 *
 * No school id in the path: the server takes it from the caller's token, so
 * nothing here can point at another school's reports.
 */
export const schoolDailyReportsApi = {
  day: async (
    params: SchoolDailyReportParams,
  ): Promise<SchoolDailyReportDay & { meta: PaginationMeta }> => {
    const response = await apiClient.get<ApiSuccess<SchoolDailyReportDay>>(
      '/institute/daily-reports/school',
      { params },
    );

    return {
      ...response.data.data,
      meta: response.data.meta ?? {
        page: params.page,
        limit: params.limit,
        total: response.data.data.items.length,
        totalPages: 1,
      },
    };
  },
};
